import { ToastContainer } from 'react-toastify'
import { RouterProvider } from 'react-router-dom'
import 'react-toastify/dist/ReactToastify.css'
import { GlobalStyle } from './styles/global'
import router from './Routes'
import Providers from './providers'
// ! Deactivated at the request of Lino and Marcelo due to self-incurred costs.
// ! in 19-11-25
// import { datadogRum } from '@datadog/browser-rum'
// import { DATADOG_STAGE } from './config'
import { Resigin } from './Pages/Resignin'

// ! Deactivated at the request of Lino and Marcelo due to self-incurred costs.
// ! in 19-11-25
// datadogRum.init({
//   applicationId: 'f2e14a1e-1a40-4c5c-a1ee-a7ce37c8e81b',
//   clientToken: 'pub7600350ccecab3065164dde0ec23d593',
//   // `site` refers to the Datadog site parameter of your organization
//   // see https://docs.datadoghq.com/getting_started/site/
//   site: 'datadoghq.com',
//   service: 'producerdashboardapp',
//   env: DATADOG_STAGE,
//   // Specify a version number to identify the deployed version of your application in Datadog
//   // version: '1.0.0',
//   sessionSampleRate: 100,
//   sessionReplaySampleRate: 100,
//   trackUserInteractions: true,
//   trackResources: true,
//   trackLongTasks: true,
//   defaultPrivacyLevel: 'mask-user-input',
// })

const App = () => {
  // Bypass Providers and Router for the resignin utility route
  if (
    typeof window !== 'undefined' &&
    (window.location.pathname === '/resignin' ||
      window.location.pathname === '/resignin/')
  ) {
    return <Resigin />
  }

  return (
    <Providers>
      <div className="App">
        <ToastContainer />
        <GlobalStyle />
        <RouterProvider router={router} />
      </div>
    </Providers>
  )
}

export default App
